import Vue from 'vue';
import Vuex from 'vuex';
import VuexORM from '@vuex-orm/core';

import PortalSettings from './models/PortalSettings';
import Category from './models/Category';
import Package from './models/Package';
import Activity from './models/Activity';
import P2P from './models/P2P';
import Product from './models/Product';
import Agent from './models/Agent';
import Cart from './models/Cart';
import CartItem from './models/CartItem';

import AvailabilityDay from './models/AvailabilityDay';

Vue.use(Vuex);

const database = new VuexORM.Database();
database.register(PortalSettings);
database.register(Category);
database.register(Package);
database.register(Activity);
database.register(P2P);
database.register(Product);
database.register(Agent);
database.register(Cart);
database.register(CartItem);
database.register(AvailabilityDay);

export default new Vuex.Store({
  plugins: [VuexORM.install(database)],

  state: {
    activeDate: new Date(),
    activeCartId: 0
  },

  getters: {
    activeCart: state => {
      return Cart.query().with('items').find(state.activeCartId) || new Cart();
    }
  },

  mutations: {
    updateActiveDate(state, date) {
      state.activeDate = date;
    },

    updateActiveCartId(state, cartId) {
      state.activeCartId = cartId;
    }
  },

  actions: {
    setActiveDate({ commit }, date) {
      commit('updateActiveDate', date);
    },

    setActiveCartId({ commit }, cartId) {
      commit('updateActiveCartId', cartId);
    },
  }
});
